import { GsFormSchema } from 'libs/shared/src/components/gs-form/interfaces/gs-form-schema';
import { DEFAULT_CONFIG } from '../../../services/config/default.config';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { buttonSchemaFields } from './../basics/button-fields.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/**
 * The schema for the text component form.
 * Defines the fields to display for the form.
 */
export const MEMBER_REMOVE_PROFILE_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    ...SPACING_SCHEMA,
    {
      formControlName: 'buttonText',
      label: 'components.memberRemoveProfile.schema.buttonText',
      type: 'text',
      inputType: 'text',
      default: 'Profil löschen'
    },
    {
      formControlName: 'confirmCheckboxText',
      label: 'components.memberRemoveProfile.schema.confirmCheckboxText',
      type: 'text',
      default: 'Ich möchte mein Profil endgültig löschen'
    },
    {
      formControlName: 'warningText',
      label: 'components.memberRemoveProfile.schema.warningText',
      type: 'text',
      default:
        'Bitte beachte, dass das Löschen deines Profils ein unumkehrbarer Schritt ist und sämtliche damit verbundenen Daten dauerhaft entfernt werden.'
    },
    {
      formControlName: 'buttons',
      label: 'components.memberRemoveProfile.schema.buttons',
      type: 'group',
      expandable: true,
      default: DEFAULT_CONFIG.uiElements?.buttons ?? {},
      fields: buttonSchemaFields()
    }
  ]
};
